import { ArrowBackRounded } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../controls";
import { action, API, controller } from "../../../../api/api";
import { PrintDiv, ToFormData } from "../../../../hooks/Method";
import PrintReturnReceipt from "../List/PrintReturnReceipt";

const Header = ({ values, setAlert }) => {
  const [receiptData, setReceiptData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure?",
      subTitle:
        "Please review carefully before submitting. This action is final and cannot be undone.",
      confirmBtnTitle: "Confirm",
      cancelBtnTitle: "Review",
      onConfirm: () => {
        confirmSubmit();
      },
    });
  };

  const confirmSubmit = () => {
    const onComplete = (res) => {
      if (res && res.status === 200) {
        setAlert((j) => ({
          ...j,
          isOpen: false,
          type: "",
          title: "",
          subTitle: "",
        }));
        setReceiptData({ ...res.result });
        handlePrintReceipt();
      }
      setLoading(false);
    };

    setLoading(true);
    API(controller.StockReturn + action.Post).post(
      ToFormData({
        ...values,
        createDate: new Date().toISOString(),
        stockReturnItems: values.stockReturnItems.map((j) => ({
          ...j,
          prod: "",
          varProd: "",
        })),
      }),
      onComplete
    );
  };

  const handlePrintReceipt = () => {
    setTimeout(() => {
      PrintDiv("printReturnReceipt");
      navigate("/return_stock");
    }, 500);
  };

  return (
    <>
      <div className="hidden" id="printReturnReceipt">
        {receiptData && receiptData.id && (
          <PrintReturnReceipt data={receiptData} />
        )}
      </div>

      <div className="flex justify-between items-center p-[10px]">
        <div className="flex items-center gap-2">
          <div>
            <IconButton size="small" onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton>
          </div>

          <div>
            <span className="font-semibold text-gray-500 uppercase">
              Supplier Return
            </span>
          </div>
        </div>

        <div>
          <Button
            disabled={values.stockReturnItems.length > 0 ? false : true}
            onClick={handleSubmit}
            loading={loading}
          >
            Submit Return
          </Button>
        </div>
      </div>
    </>
  );
};

export default Header;
